import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { ScrollableContent } from '@/components/scroll/scrollableContent';
import { ScrollableWrapper } from '@/components/scroll/scrollableContext';
import { ScrollableHeader } from '@/components/scroll/scrollableHeader';
import { SelectedItemsBody } from './selectedItemsBody';
import { SelectedItemsHeader } from './selectedItemsHeader';
export const SelectedItemsBox = t0 => {
  const $ = _c(12);
  const {
    items,
    entityType,
    renderItem,
    itemKey,
    onRemove,
    clearAll
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: "0 24px 12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${items.length} ${items.length === 1 ? entityType : `${entityType}${entityType.endsWith("s") ? "es" : "s"}`} added`;
  let t3;
  if ($[1] !== clearAll || $[2] !== t2) {
    t3 = <ScrollableHeader hideBorderWhenOnTop={true}><Stack sx={t1}><SelectedItemsHeader title={t2} clearAll={clearAll} /></Stack></ScrollableHeader>;
    $[1] = clearAll;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== itemKey || $[5] !== items || $[6] !== onRemove || $[7] !== renderItem) {
    t4 = <ScrollableContent><SelectedItemsBody items={items} renderItem={renderItem} itemKey={itemKey} onRemove={onRemove} /></ScrollableContent>;
    $[4] = itemKey;
    $[5] = items;
    $[6] = onRemove;
    $[7] = renderItem;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Stack className="overflow-hidden"><ScrollableWrapper>{t3}{t4}</ScrollableWrapper></Stack>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};